module.exports = __webpack_public_path__ + "static/img/4.54ff7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/4.png
// module id = GWgK
// module chunks = 4